import React from "react";
import { object, shape } from "prop-types";
import { getCollectionTemplate } from "../../get-collection-template";
import { LazyCollection, LazyLoadImages } from "@quintype/components";
import "./channel-one.m.css";

export const HomeChannelOne = ({ data }) => {
  return (
    <div>
      <div>
        <LazyLoadImages>
          <LazyCollection collection={data.collection} collectionTemplates={getCollectionTemplate} lazyAfter={22} />
        </LazyLoadImages>
      </div>
    </div>
  );
};

HomeChannelOne.propTypes = {
  data: shape({
    collection: object,
  }),
};
